import { useTranslation } from 'react-i18next'
import { Textarea } from '@structural-climbing/ui'

/** Matches MAX_ROUTE_COMMENT_LENGTH in the Worker and the CHECK on route_comments.body. */
export const MAX_ROUTE_COMMENT_LENGTH = 500

// The counter only appears near the limit, so it never nags a short note.
const COUNTER_FROM = 400

interface Props {
  value: string
  onValueChange: (value: string) => void
}

/**
 * A climber's note to the setters. Only the gym's staff read it, and the hint
 * under the field says so: a climber writes differently when they know other
 * climbers will not see it.
 */
export function RouteCommentField({ value, onValueChange }: Props) {
  const { t } = useTranslation()
  const nearLimit = value.length >= COUNTER_FROM

  return (
    <Textarea
      label={t('routes.commentLabel')}
      placeholder={t('routes.commentPlaceholder')}
      description={
        nearLimit
          ? t('routes.commentCounter', { count: value.length, max: MAX_ROUTE_COMMENT_LENGTH })
          : t('routes.commentHint')
      }
      value={value}
      onValueChange={onValueChange}
      maxLength={MAX_ROUTE_COMMENT_LENGTH}
      minRows={2}
      maxRows={6}
      data-testid="route-comment"
    />
  )
}
